// extracted by mini-css-extract-plugin
export var avatarContainer = "_h4-0";
export var avatarTypingWave = "_h4-i";
export var gray = "_h4-f";
export var green = "_h4-c";
export var icon = "_h4-9";
export var image = "_h4-1";
export var lg = "_h4-6";
export var md = "_h4-5";
export var presenceDot = "_h4-b";
export var red = "_h4-d";
export var sm = "_h4-4";
export var status = "_h4-a";
export var typingDot = "_h4-h";
export var typingPill = "_h4-g";
export var xl = "_h4-7";
export var xs = "_h4-3";
export var xxl = "_h4-8";
export var xxs = "_h4-2";
export var yellow = "_h4-e";